import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Message from './Message'

const Wrapper = styled.div`
    bottom: 30px;
    left: -300px;
    max-height: 200px;
    position: absolute;
    transition: left 0.3s;
    width: 300px;
    z-index: 5;

    ${({ isVisible }) =>
        isVisible &&
        `
      left: 75px;
    `}
`

function PromptMessage({ id, isVisible, title, body, onClickDismiss }) {
    return (
        <Wrapper isVisible={isVisible}>
            <Message body={body} dismissed={false} id={id} isDismissible onClickDismiss={onClickDismiss} theme="prompt" title={title} />
        </Wrapper>
    )
}

PromptMessage.propTypes = {
    body: PropTypes.string,
    id: PropTypes.string,
    isVisible: PropTypes.bool,
    onClickDismiss: PropTypes.func,
    title: PropTypes.string,
}

PromptMessage.defaultProps = {
    body: '',
    id: '',
    isVisible: false,
    onClickDismiss: () => null,
    title: '',
}

export default PromptMessage
